export const SOUNDS = {
    SHOW_DENOMINATIONS: 'showDenominationsSound',
    HIDE_DENOMINATIONS: 'hideDenominationsSound',
    BET_SLIDE: 'betSlide',
    SPIN: 'spinSound',
} as const

export type SoundName = (typeof SOUNDS)[keyof typeof SOUNDS]
